<mat-card appearance="raised" class="anon-form--container mat-elevation-z12">
  <div class="anon-form--header dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".anon-form--container" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
    <h5 class="anon-form--title">{{ sysText.anonymousLeaveHoursRequest_title }}</h5>
    <p class="body2 anon-form--subtitle">{{ sysText.anonymousLeaveHoursRequest_subtitle }}</p>
  </div>
  <mat-card-content>
    <form [formGroup]="form" class="anon-form--form">
      <app-input-field
        [icon]="'person'"
        [label]="sysText.employee"
        [control]="form.controls.employee"
        [autocomplete]="'name'">
      </app-input-field>
      <app-input-field
        [control]="form.controls.employer"
        [isDisabled]="true"
        [icon]="'business'"
        [label]="sysText.company"
        [inputType]="'string'">
      </app-input-field>
      <app-input-field
        [icon]="'date_range'"
        [label]="sysText.caseNumber"
        [inputType]="'number'"
        [control]="form.controls.caseNumber">
      </app-input-field>
      <app-text-area
        [control]="form.controls.comments"
        [icon]="'comment'"
        [label]="sysText.comments">
      </app-text-area>
      <app-submit-hours-form-array
        [leaveHoursFormArray]="leaveHours"
        [group]="form"
        [sysText]="sysText">
      </app-submit-hours-form-array>
    </form>

    <!-- submit keeps focus while sending: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    @let isSubmitting = isSubmitting$ | async;
    <button
      mat-flat-button
      color="accent"
      class="button submit--button"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && onSubmit()">
      {{ sysText.submitRequest }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>

    <div class="anon-form--link caption">
      <a [routerLink]="'/' + accountRoutePaths.LOGIN">
        {{ sysText.backToLogin | capitalizefirst }}
      </a>
    </div>
  </mat-card-content>
</mat-card>